import router, { RouteItemType } from '~/core/router';
import { withAuthAnalyticsLayout } from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import {
  getResetPasswordTitle,
  ResetPasswordPath,
} from '~/modules/auth/constants';

const PolyLLMResetPassword = lazyComponentLoader(
  () => import('~/projects/polyllm-chat/components/ResetPassword'),
);

const PolyLLMResetPasswordRoute: RouteItemType = {
  Component: withAuthAnalyticsLayout(PolyLLMResetPassword),
  path: ResetPasswordPath,
  getTitle: getResetPasswordTitle,
};

router.setSignInRedirectPath('/');
router.addAuthRoutes([PolyLLMResetPasswordRoute]);
